import {
  getItemFromStorage,
  removeItemFromStorage,
  setItemToStorage,
} from 'utils/MMKVStorageUtils';
import { StateStorage } from 'zustand/middleware';

export const zustandMMKVStorage: StateStorage = {
  setItem: (name, value) => {
    return setItemToStorage(name, value);
  },
  getItem: (name) => {
    const value = getItemFromStorage(name);
    return value ?? null;
  },
  removeItem: (name) => {
    return removeItemFromStorage(name);
  },
};
